import { Environments } from './types/global';
export const BASE_PATH = '/flight';
export const DEFAULT_PASSENGER_AGE = 30;
export const EMPTY_INPUT_VALUE = '';
export const SEC = 1000;
export const MIN = 60 * SEC;
export const HOUR = 60 * MIN;
export const DAY = 24 * HOUR;
export const WEEK = 7 * DAY;
export const FORMS_STATE_NAMESPACE = 'forms';
export const FLIGHTS_STATE_NAMESPACE = 'flights';
export const LOCALSTORAGE_MODELS = [
    FORMS_STATE_NAMESPACE,
    FLIGHTS_STATE_NAMESPACE,
];
export const IS_PRODUCTION = __ENV__ === Environments.PRODUCTION;
export const IS_DEVELOPMENT = __ENV__ === Environments.DEVELOPMENT;
export const SENTRY_CONFIG = {
    dsn: __SENTRY_DSN__,
    environment: __ENV__,
    ...(IS_DEVELOPMENT && { debug: true }),
};
export const MARKETING_PARAMS = [
    'partnerId',
    'marker',
    'marker2',
    'marker3',
    'marker4',
    'srcsale',
];
export const MODAL_PRODUCT_ID_QUERY_PARAM = 'modalProductId';
export const IS_IGNORE_LOCAL_STORAGE = 'isIgnoreLocalStorage';
export const ORDER_ID_QUERY_PARAM = 'orderId';
export const ASSETS_SRC = {
    FONTS: `${__FLIGHT_STATIC_URL__}front/fonts`,
    IMAGES: `${__FLIGHT_STATIC_URL__}front/images`,
    VIDEO: `${__FLIGHT_STATIC_URL__}front/video`,
};
export const DOCS_SRC = {
    INSURANCE_PROGRAM: `${__FLIGHT_STATIC_URL__}front/docs/insurance-program.pdf`,
    INSURANCE_RULES: `${__FLIGHT_STATIC_URL__}front/docs/insurance-rules.pdf`,
};
export const COVERAGE = {
    DELAY_PER_HOUR: 1000,
    CANCELLATION: 12000,
    REDIRECT: 5000,
    MIN_DELAY_HOURS: 3,
};
export const SCRIPTS = {
    FONTS: `${ASSETS_SRC.FONTS}/fonts.css`,
};
export const DATE_MASK = { mask: '00.00.0000' };
export const TIME_MASK = { mask: '00:00' };
export const FORM_DATE_FORMAT = 'dd.MM.yyyy';
export const DENIED_MESSAGES_FOR_BREADCRUMBS = [
    'Fast Refresh',
    'Reach goal',
    'PageView. Counter',
    'Leadhit',
];
export const DENIED_URLS_FOR_BREADCRUMBS = [
    'mc.yandex.ru',
    'google.analytics.com',
    'gso.amocrm.ru',
    'leadhit.io',
    'stats.g.doubleclick.net',
];
export const MIN_PASSENGERS_AMOUNT = 1;
export const MAX_PASSENGERS_AMOUNT = 10;
export const MIN_EMAILS_AMOUNT = 1;
export const MAX_EMAILS_AMOUNT = 4;
export const MAX_AGE = 100;
export const MIN_INSURER_AGE = 18;
export const MAX_NAME_LENGTH = 50;
export const CURRENCIES_BADGES = {
    rub: '₽',
    usd: '$',
    eur: '€',
};
